class InfiniteScroll extends HTMLElement {
  static fetchedUrls = new Set(); // ✅ remember which next-page URLs we already loaded

  constructor() {
    super();

    // ✅ prevent double-init on the same element
    if (this.dataset.infiniteInitialized === 'true') return;
    this.dataset.infiniteInitialized = 'true';

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger === 'infinite') {
      // Observe when the sentinel comes into view near the bottom
      this._observer = new IntersectionObserver(
        this.handleIntersection.bind(this),
        { rootMargin: '0px 0px 200px 0px' }
      );
      this._observer.observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;

    const url = (this.dataset && this.dataset.url) ? this.dataset.url : null;
    if (!url) return;

    // ✅ do not fetch the same URL twice
    if (InfiniteScroll.fetchedUrls.has(url)) return;
    InfiniteScroll.fetchedUrls.add(url);

    this.classList.add('loading', 'disabled');

    // (Your code only renders the product grid; no need to iterate "sections")
    InfiniteScroll.renderSectionFromFetch(url).finally(() => {
      // remove loading state; a new sentinel will be inserted with the next page
      this.classList.remove('loading');
      // keep disabled so this instance doesn't re-fire; new pagination will create a new <infinite-scroll>
      this.classList.add('disabled');
    });
  }

  handleIntersection(entries, observer) {
    const entry = entries && entries[0];
    if (!entry || !entry.isIntersecting) return;

    // stop this sentinel from firing again
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    // Kept for theme compatibility; not used anymore for looping.
    return [{ section: document.getElementById('product-grid')?.dataset.id }];
  }

  static renderSectionFromFetch(url) {
    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderPagination(html) {
    const container = document
      .getElementById('ProductGridContainer')
      ?.querySelector('.pagination-wrapper');

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nextWrapper = doc
      .getElementById('ProductGridContainer')
      ?.querySelector('.pagination-wrapper');

    if (!container) return;

    if (nextWrapper) {
      // Replace with new pagination/sentinel. The new <infinite-scroll> will auto-init.
      container.innerHTML = nextWrapper.innerHTML;
    } else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const existingGrid = document.getElementById('product-grid');
    if (!existingGrid) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incomingGrid = doc.getElementById('product-grid');
    if (!incomingGrid) return;

    // Append next page’s products
    existingGrid.insertAdjacentHTML('beforeend', incomingGrid.innerHTML);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
